import { createAction } from 'redux-actions';

export const startEditProfileSubmit = createAction('START_EDIT_PROFILE_SUBMIT');

export const resolveEditProfileSubmit = createAction('RESOLVE_EDIT_PROFILE_SUBMIT');
